<template>
  <div id="topic">
    <Cutscenes v-if="showCutscenes"></Cutscenes>
    <download-nav></download-nav>

    <template v-if="activity">
      <div class="top_pic" :style="'background-image:url('+activity.image+')'" v-if="activity.image"></div>
      <a :href="activity.url||'javascript:;'" class="topic_link" v-if="activity.tag_desc">
        <span class="txt">{{activity.tag_desc}}</span>
        <i class="arrow"></i>
      </a>
    </template>
    <div v-if="tag_info" class="topic_content">
      <p class="topic_name">
        {{'#'+tag_info.tag_name}}
      </p>
      <div class="counts">
        <span>感兴趣 {{tag_info.follow_count}}</span>
        <span>讨论 {{tag_info.thread_count}}</span>
      </div>
      <div class="count-down" v-if="tag_info.end_at!=0 && activityEndTime">
        <span class="line"></span>
        <span class="txt" v-if="!activityEndTime.isEnd">剩余 {{activityEndTime.d}}天 {{activityEndTime.h}}时 {{activityEndTime.m}}分 {{activityEndTime.s}}秒</span>
        <span v-else class="txt">活动已结束</span>
        <span class="line"></span>
      </div>
      <p class="topic_desc">
        {{tag_info.tag_desc}}
      </p>
      <a v-if="topicMode != 0" :href="tag_info.url" class="detail_btn">查看详情</a>
    </div>
    <tab-nav v-if="tabsConfig.tabs.length" :tabs="tabsConfig.tabs" :active="tabsConfig.active" @change="tabChanged"></tab-nav>
    <!-- 普通列表 -->
    <div class="tab_content" v-if="listMode==0 && normalList.length">
      <div class="po_item" v-for="(poData,po_item_index) in normalList" :key="po_item_index">
        <div class="po_top">
          <div class="user_info">
            <div class="avatar" :style="'background-image:url('+poData.face+')'"></div>
            <div class="text">
              <p :class="'user_name sex_'+poData.gender">{{poData.username}}</p>
              <p class="time">{{poData.dateline | timestamp2txt}}</p>
            </div>
          </div>
          <div class="stamp" :style="'background-image:url('+poData.tag_stick+')'"></div>
        </div>
        <div class="po_content">
          <p class="po_txt" @click="jumpPoDetail(poData.id)">
            <span class="tag">{{'#'+tag_info.tag_name}}</span>
            <span class="poContent" v-html="poData.content"></span>
          </p>
          <a :href="poData.extra.url" class="po_tag" v-if="poData.extra.titlte">
            <span class="txt">
              {{poData.extra.titlte}}
            </span>
            <i class="arrow"></i>
          </a>
          <div class="prize_tag" v-if="poData.prize">
            <div class="txt">{{poData.prize}}</div>
          </div>
          <PicBox :images="poData.images" :type="poData.type"></PicBox>
          <div class="location" v-if="poData.address" @click="jumpLocation(poData.extra.position_x,poData.extra.position_y)">{{poData.address}}</div>
        </div>
        <div class="zan_wrap" v-if="poData.praise_count>0" @click="jumpPoDetail(poData.id)">
          <div class="avatar_list">
            <div class="avatar" v-for="(item,index) in poData.praise" v-if="index<9" :key="index" :style="'background-image:url('+item.face+')'"></div>
            <div class="zan_count">{{poData.praise_count
              < 100?poData.praise_count+ '赞': '99+'}}</div>
            </div>
          </div>
          <div class="comment_list" @click="jumpPoDetail(poData.id)">
            <div class="item" v-for="(item,index) in poData.comments" :key="index" v-if="index<3">
              <span :class="'user sex_'+item.cuinfo.gender">{{item.cuinfo.username}}</span>
              <template v-if="item.ruinfo.username">
                <span class="to">回复</span>
                <span :class="'user sex_'+item.ruinfo.gender">{{item.ruinfo.username}}</span>
              </template>
              <span>：</span>
              <span v-html="item.comment"></span>
            </div>
            <div class="more" v-if="poData.comment_count>3">
              查看全部({{poData.comment_count}})
            </div>
          </div>
          <div class="po_item_ctrl">
            <div class="input_wrap" @click="openAppTopic">回复 {{poData.username}}</div>
            <i class="share" @click="openAppTopic"></i>
            <i class="zan" :class="poData.is_praise?'on':''" @click.stop="onZan(po_item_index)"></i>
          </div>
        </div>
      </div>
      <!-- 瀑布流列表  -->
      <div class="tab_content" v-if="listMode==1">
        <div class="water_fall">
          <div class="col_wrap">
            <div ref="col_0">
              <div v-for="(item,index) in waterFall.col_0" class="item" :key="index" @click="jumpPoDetail(item.id)">
                <div class="read_count">{{item.views}}</div>
                <img :src="item.images[0].url" :width="item.images[0].w" :height="item.images[0].h" />
                <p class="desc" v-html="item.content"></p>
                <div class="user_n_time">
                  <span :class="'sex_'+item.gender">{{item.username}}</span>
                  <span>{{item.dateline | timestamp2txt}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col_wrap">
            <div ref="col_1">
              <div v-for="(item,index) in waterFall.col_1" class="item" :key="index" @click="jumpPoDetail(item.id)">
                <div class="read_count">{{item.views}}</div>
                <img :src="item.images[0].url" :width="item.images[0].w" :height="item.images[0].h" />
                <p class="desc" v-html="item.content"></p>
                <div class="user_n_time">
                  <span :class="'sex_'+item.gender">{{item.username}}</span>
                  <span>{{ item.dateline | timestamp2txt }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabsConfig.active==1">

      </div>
      <BottomLoading :style="ifShowBottomLoading?'visibility:visible':'visibility:hidden'"></BottomLoading>
    </div>
</template>
<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
@import "./topic.scss";
</style>

<script>
import DownloadNav from "@/components/download_nav/DownloadNav.vue";
import TabNav from "@/components/tab_nav/TabNav.vue";
import BottomLoading from "@/components/bottom_loading/BottomLoading.vue";
import PicBox from "@/components/pic_box/PicBox.vue";
import Cutscenes from "@/components/cutscenes/Cutscenes.vue";
import Vue from "vue";
import { getParam,magicLink } from "@/untils/until.js";

var qs = require("qs");
export default {
  name: "app",
  data() {
    return {
      showCutscenes: true,
      tabsConfig: {
        tabs: [],
        active: 1
      },
      // 当前选项卡选中的类型
      curTabType: "",

      topicMode: 0, // 0普通话题 其他高级话题
      listMode: 1, // 0普通模式 1瀑布流模式
      ifShowBottomLoading: false,
      allData: null,
      hotData: null,
      activity: null,
      tag_info: null,
      t: null,
      // 普通列表要展示的数据
      normalList: [],
      // 瀑布流列表要展示的数据
      waterFall: {
        col_0: [],
        col_1: [],
        // 高度较短的列的索引
        short: 0
      },

      // 最新
      newestList: [],
      newPage: 1,
      // 热门
      hotList: [],
      hotPage: 1,
      // 排行榜
      rankList: [],
      rankPage: 1,

      // 活动倒计时对象
      activityEndTime: null
    };
  },
  components: {
    DownloadNav,
    TabNav,
    BottomLoading,
    PicBox,
    Cutscenes
  },
  methods: {
    // 切换选项卡回调
    tabChanged(index) {
      let self = this;
      self.tabsConfig.active = parseInt(index);
      if (self.topicMode == 0) {
        // 普通话题
        if (index == 0) {
          // 最新
          self.listMode = 0;
          self.normalList = self.newestList;
          self.curTabType = "newestList";
        } else if (index == 1) {
          // 热门
          self.listMode = 1;
          self.curTabType = "hotList";
          Vue.nextTick(() => {
            self.renderWaterFall(self.hotList);
          });
        }
      } else {
        // 高级话题
        if (index == 0) {
          // 排行榜
          self.listMode = 0;
          self.normalList = self.rankList;
          self.curTabType = "rankList";
        } else if (index == 1) {
          // 最新
          self.listMode = 0;
          self.normalList = self.newestList;
          self.curTabType = "newestList";
        }
      }
    },
    // 渲染瀑布流
    renderWaterFall(data) {
      let self = this;

      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        let imgRatio = data[index].images[0].h / data[index].images[0].w;
        let imgW = w;
        let imgH = w * imgRatio;
        let item = data[index];
        item.images[0].w = imgW;
        item.images[0].h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        Vue.nextTick(function() {
          let h0 = self.$refs.col_0.offsetHeight;
          let h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;
          if (index >= data.length) {
            return;
          }
          calcWaterFall(data);
        });
      }
    },
    // 跳转详情页
    jumpPoDetail(po_id) {
      this.$router.push("/detail/" + po_id);
    },
    // 加载po列表数据
    loadPoListData(mode, page, cb) {
      let self = this;
      let api = "/index.php?r=web/ajaxposttaglist&v=4.2.0";
      let reqData = {};
      let obj = {
        params: {}
      };
      switch (mode) {
        case "rank":
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "2",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "2",
            tag_id: self.$route.params.tag_id
          };
          break;
        case "new":
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "0",
            tag_id: self.$route.params.tag_id
          };
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "0",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          break;
        case "hot":
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "1",
            tag_id: self.$route.params.tag_id
          };
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "1",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          break;
        default:
          break;
      }

      if (getParam("from") != null) {
        obj.params.from = getParam("from");
      }
      if (getParam("isappinstalled") != null) {
        obj.params.isappinstalled = getParam("isappinstalled");
      }
      reqData = { data: JSON.stringify(obj) };
      if (self.ifShowBottomLoading) {
        return;
      }
      self.ifShowBottomLoading = true;
      self.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          let resBody = res.data;
          if (resBody.ret == 0) {
            cb && cb(resBody.data.threads);
          }
          self.ifShowBottomLoading = false;
        });
    },
    // 倒计时 endTimeStamp 毫秒
    countDown(endTimeStamp) {
      endTimeStamp = parseInt(endTimeStamp);
      let nowTimestamp = Date.now();
      let leftTime = endTimeStamp - nowTimestamp;

      let data = {};

      if (leftTime > 0) {
        var d = Math.floor(leftTime / 1000 / 24 / 60 / 60);
        var h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        var m = Math.floor((leftTime / 1000 / 60) % 60);
        var s = Math.floor((leftTime / 1000) % 60);
        data = {
          d,
          h,
          m,
          s,
          isEnd: false
        };
      } else {
        data = {
          d: 0,
          h: 0,
          m: 0,
          s: 0,
          isEnd: true
        };
      }

      return data;
    },
    // 点赞
    onZan(index) {
      if (!globalData.isLogin) {
        window.location.href =
          "http://my2.xizi.com/user/social-login?type=wx&referrer=" +
          encodeURIComponent(location.href);
        return;
      }
      let self = this;
      let api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      let preZanState = self[self.curTabType][index].is_praise;
      let reqData = {
        data: JSON.stringify({
          params: {
            id: self[self.curTabType][index].id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self[self.curTabType][index].is_praise = preZanState == 0 ? 1 : 0;
      self.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          console.log(resBody);
          if (resBody.ret !== 0) {
            self[self.curTabType][index].is_praise = preZanState;
          }
          self.normalList = self[self.curTabType];
        })
        .catch(() => {
          self[self.curTabType][index].is_praise = preZanState;
          self.normalList = self[self.curTabType];
        });
      self.normalList = self[self.curTabType];
    },
    jumpLocation(x, y) {
      // wx.openLocation({
      //     latitude: y, // 纬度，浮点数，范围为90 ~ -90
      //     longitude: x, // 经度，浮点数，范围为180 ~ -180。
      //     name: '', // 位置名
      //     address: '', // 地址详情说明
      //     scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
      //     infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      // });
    },
    openAppTopic() {
      magicLink('po_tag','tag_id='+ this.$route.params.tag_id)
    },
    formatSticker() {
      let potxt = document.getElementsByClassName("po_txt");

      let commentTxt = document.getElementsByClassName("comment_list");

      let waterFallContent = document.getElementsByClassName("desc");

      if (potxt.length) {
        let txtFontSize = Number.parseInt(
          window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        let commentFontSize = Number.parseInt(
          window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]
        );
        this.forCircle(commentTxt, commentFontSize);
      }
      if (waterFallContent.length) {
        let waterFallFontSize = Number.parseInt(
          window
            .getComputedStyle(waterFallContent[0], null)
            .fontSize.split("px")[0]
        );
        this.forCircle(waterFallContent, waterFallFontSize);
      }
    },
    forCircle(item, fontSize) {
      for (let i = 0, length = item.length; i < length; i++) {
        let img = item[i].querySelectorAll("img");
        if (img.length) {
          for (let j = 0, length = img.length; j < length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    }
  },
  created() {
    // //加载首屏数据
    let api = "/index.php?r=web/ajaxposttaglist&v=4.2.0";
    let self = this;
    let obj = {
      params: {
        page: 1,
        tag_info: "1",
        type_id: "1",
        tag_id: self.$route.params.tag_id
      }
    };
    if (getParam("from") != null) {
      obj.params.from = getParam("from");
    }
    if (getParam("isappinstalled") != null) {
      obj.params.isappinstalled = getParam("isappinstalled");
    }
    let reqData = {
      data: JSON.stringify(obj)
    };
    this.axios
      .post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        console.log(response.data);
        let resBody = response.data;
        if (resBody.ret == 0) {
          self.allData = resBody.data;
          self.showCutscenes = false;
          //配置微信分享
          // window.setShareConfig({
          // title: resBody.data.tag_info.share_title,
          // desc: "惠州生活必备-西子湖畔App",
          // link: resBody.data.tag_info.share_url,
          // imgUrl: resBody.data.tag_info.share_image_url
          // });
          wx.ready(function() {
            wx.onMenuShareTimeline({
              title: resBody.data.tag_info.share_title,
              link: resBody.data.tag_info.share_url,
              imgUrl: resBody.data.tag_info.share_image_url
            });
            wx.onMenuShareAppMessage({
              title: resBody.data.tag_info.share_title,
              desc: "惠州生活必备-西子湖畔App",
              link: resBody.data.tag_info.share_url,
              imgUrl: resBody.data.tag_info.share_image_url
            });
          });
          // 活动倒计时
          if (resBody.data.tag_info) {
            let endAt = parseInt(resBody.data.tag_info.end_at);
            let timer = setInterval(() => {
              let leftTime = self.countDown(endAt);
              self.activityEndTime = leftTime;
              if (endAt <= 0) {
                clearInterval(timer);
              }
            }, 1000);
          }
          // 设置话题模式
          this.topicMode = resBody.data.tag_info.if_prize;
          if (this.topicMode == 0) {
            // 普通话题
            this.tabsConfig.tabs = ["最新", "热门"];
            this.hotList = resBody.data.threads;

            // 渲染最热数据
            this.normalList = this.hotList;
            this.curTabType = "hotList";
            this.renderWaterFall(this.hotList);
            // 预加载最新数据
            this.loadPoListData("new", 1, data => {
              this.newestList = data;
            });
          } else {
            // 高级话题
            this.tabsConfig.tabs = ["排行榜", "最新"];
            this.tabsConfig.active = 0;
            this.listMode = 0;
            // 加载排行榜数据
            this.loadPoListData("rank", 1, data => {
              this.rankList = data;
              // 渲染排行榜数据
              this.normalList = this.rankList;
              this.curTabType = "rankList";
              // 保存最新数据
              this.newestList = resBody.data.threads;
            });
          }
          this.tag_info = resBody.data.tag_info;
          this.activity = resBody.data.activity;
        }
      });
  },
  mounted() {
    let self = this;
    document.title = "话题详情";
    window.addEventListener("scroll", function(e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH) {
        switch (self.tabsConfig.tabs[self.tabsConfig.active]) {
          case "排行榜":
            self.loadPoListData("rank", self.rankPage + 1, data => {
              if (data.length) {
                self.rankPage++;
                self.rankList = self.rankList.concat(data);
                self.normalList = self.rankList;
              }
            });
            break;
          case "最新":
            self.loadPoListData("new", self.newPage + 1, data => {
              if (data.length) {
                self.newPage++;
                self.newestList = self.newestList.concat(data);
                self.normalList = self.newestList;
              }
            });
            break;
          case "热门":
            self.loadPoListData("hot", self.hotPage + 1, data => {
              if (data.length) {
                self.hotPage++;
                self.hotList = self.hotList.concat(data);
                self.renderWaterFall(self.hotList);
              }
            });
            break;
          default:
            break;
        }
      }
    });
    // this.wxConfig();
  },
  updated() {
    this.formatSticker();
  }
};
</script>



// WEBPACK FOOTER //
// Topic.vue?7187e612